import styled from "styled-components";

// components
import Grid from "core/Grid";
import SectionContainer from "core/SectionContainer";

// styles
import breakpoints from "core/breakpoints";
import colors from "core/colors";

//helpers
import { convertPxToRem } from "frontend/components/helpers";

// constants
const MATERIAL_NEGATIVE_MARGIN = 16;
const MIN_HEIGHT_TOTAL_PX = 661;
const MIN_HEIGHT_TOTAL_REM =
    (MIN_HEIGHT_TOTAL_PX + MATERIAL_NEGATIVE_MARGIN) / 16;
const TOP_BOTTOM_PADDING_PX = 36;
const TOP_BOTTOM_PADDING_REM = TOP_BOTTOM_PADDING_PX / 16;
const GRID_CONTAINER_MIN_HEIGHT_REM =
    MIN_HEIGHT_TOTAL_REM - TOP_BOTTOM_PADDING_REM * 2; // calculates total of 661px -> REM height for the black area

/*---------------------------
| RootWrapper
---------------------------*/
export const RootWrapperStyled = styled(SectionContainer)`
    > section {
        /* mobile-only styles: */
        padding: 0;

        /* tablet-only styles: */
        @media (min-width: ${breakpoints.tablet
                .rem}) and (max-width: ${breakpoints.beforeDesktop.rem}) {
            padding: ${TOP_BOTTOM_PADDING_REM}rem 1.25rem; /* 36px 20px */
        }

        /* desktop-only styles: */
        @media (min-width: ${breakpoints.desktop.rem}) {
            padding: ${TOP_BOTTOM_PADDING_REM}rem 1.5rem; /* 36px 24px */
        }
    }
`;

/*---------------------------
| Grid Container
---------------------------*/
export const GridContainerStyled = styled(Grid)`
    // tablet + desktop styles:
    @media (min-width: ${breakpoints.tablet.rem}) {
        min-height: ${GRID_CONTAINER_MIN_HEIGHT_REM}rem;
    }
`;

/*---------------------------
| AssetHero Grid Item
---------------------------*/
export const AssetHeroColGridItem = styled(Grid)`
    text-align: center; // justify center is not working with image
`;

/*---------------------------
| Sidebar Grid Item
---------------------------*/
export const SidebarColGridItem = styled(Grid)`
    color: ${colors.primary.diamond};

    /* Mobile-only style: */
    && {
        @media (max-width: ${breakpoints.beforeTablet.rem}) {
            max-width: ${convertPxToRem({ px: 480 })};
            margin: auto;
            padding-top: ${convertPxToRem({ px: TOP_BOTTOM_PADDING_PX })};
            padding-right: ${convertPxToRem({ px: 15 })};
            padding-bottom: ${convertPxToRem({ px: TOP_BOTTOM_PADDING_PX })};
            padding-left: ${convertPxToRem({ px: 15 })};
        }
    }
`;

export const InnerContentStyled = styled.div`
    @media (min-width: ${breakpoints.tablet.rem}) {
        max-width: ${convertPxToRem({ px: 350 })};
    }
`;
